import React from 'react';

import { STATES } from '../landingPageData';
import css from './StateDirectory.module.css';

const StateDirectory = () => {
  return (
    <section className={css.section} id="states">
      <div className={css.container}>
        <div className={css.head}>
          <span className={css.overline}>Browse by coverage area</span>
          <h2 className={css.title}>Providers covering your market.</h2>
          <p className={css.sub}>
            Providers covering the three largest US event markets. See live availability and reviews
            before you post.
          </p>
        </div>

        <div className={css.states}>
          {STATES.map(state => (
            <div key={state.name} className={css.state}>
              <h3 className={css.stateName}>{state.name}</h3>
              <div className={css.cities}>
                {state.cities.map(city => (
                  <span key={city} className={css.city}>
                    {city}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StateDirectory;
